import React, { ElementType } from 'react';

import { MODAL_BODY_SCROLL, MODAL_FOOTER_PINNED } from './modal-layout';

interface ModalProps {
    children: React.ReactNode;
    className?: string;
    as?: ElementType;
}

export const ModalTitle = ({ children, className, as: Component = `h5` }: ModalProps) => {
    return <Component className={className ? className : ``}>{children}</Component>;
};

export const ModalBody = ({ children, className, as: Component = `div` }: ModalProps) => {
    const merged = [MODAL_BODY_SCROLL, className].filter(Boolean).join(' ');
    return <Component className={merged}>{children}</Component>;
};

export const ModalFooter = ({ children, as: Component = `div`, className }: ModalProps) => {
    const merged = [MODAL_FOOTER_PINNED, className].filter(Boolean).join(' ');
    return <Component className={merged}>{children}</Component>;
};
